<template>
  <div class="question-view">
    <FixedFontSizeSelector>
    <div class="quest" :style="`${mode == 'viewAnswer' ? `--beforeShow: '';` : `--beforeShow: none;`}`">
      <div class="title">
        <vue-mathjax @onRenderComplete="onRenderComplete(++mathjaxNum)" :formula="form.title" :safe="false"/>
      </div>

      <div class="matrix">
        <div class="column" v-for="(col, idx) in matrix" :key="idx">
          <div v-for="(row, index) in col" :key="index">
            <div class="direction E" v-if="row.type == -2"></div>
            <div class="direction W" v-else-if="row.type == -3"></div>
            <div class="direction S" v-else-if="row.type == -4" ></div>
            <div class="direction N" v-else-if="row.type == -5" ></div>
            <div :class="['row', row.type == -1 && 'hide', row.right && 'right', row.bottom && 'bottom']" v-else>
              <!-- 明文 -->
              <span class="proclaimed" v-if="row.type == 0">{{ row.value }}</span>
              <div class="ciphertext" v-else-if="row.type == 1">
                <input type="number" class="no-spin" v-model="row.value" name="" id="ciphertext" @input="debounce(row)">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    </FixedFontSizeSelector>
  </div>
</template>

<script>
import { debounce } from '../../../../utils/throttle'
import EventBus from '../../static/event-bus'
import FixedFontSizeSelector from '@/views/student/components/FontSizeSelector'
export default {
  components: {
    FixedFontSizeSelector
  },
  props: ['form', 'mode'],
  data() {
    return {
      mathjaxNum: 0,
      valNum: 0,
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: [],
      // 记录答题次数
      limit: 0,

      matrix: []
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    onRenderComplete(i) {
      let num = 1

      if(i == num) {
        this.$parent.loading = false
      }
    },
    // 重置
    resetting() {
      // 数据清空
      this.$emit('permissions', false)
      this.limit = 0
      
      // 清除界面数据
      // let blocks = document.querySelectorAll('.ciphertext > input')
      // for(let i = 0; i < blocks.length; i++) {
      //   blocks[i].value = ''
      // }

      // 清空数据
      // 将整个数列扁平化，后过滤出type = 1的数据
      this.matrix.flat().filter(its => its.type == 1 && (its.value = ''))
      
      this.recordQuestion = []
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.repariRecordQuestion()
    },
    repariRecordQuestion() {
      this.$emit('repariRecordQuestion', this.recordQuestion, this.limit)
    },
    showTrueFalse() {
      let { form, recordQuestion } = this,
      answers = form.answers,
      inputs = document.querySelectorAll('.ciphertext'),
      // 将整个数列扁平化，后过滤出type = 1的数据
      inputsMatrix = this.matrix.flat().filter(its => its.type == 1 && its)
      if(recordQuestion.length == 0) {
        return ;
      }
      console.log(inputsMatrix)
      this.limit = 1
      

      console.log(inputs)
      for(let i = 0; i < inputs.length; i++) {
        // let input = inputs[i].querySelector('input')
        inputsMatrix[i].value = recordQuestion[i] ? recordQuestion[i].value : ''

        if(this.mode == 'question') {
          continue ;
        }

        if(recordQuestion[i] != undefined && recordQuestion[i].value == answers[i].value) {
          inputs[i].classList.add('determine-success-br')
        } else {
          inputs[i].classList.add('determine-error-br')
        }
      }
    },
    debounce(row) {
      EventBus.$emit('nextStatus', false)
      debounce(this.updateValue, 500, row)
    }, 
    updateValue(item) {
      EventBus.$emit('nextStatus', true)
      item.value = item.value.trim()

      let vals = document.querySelectorAll('.ciphertext'),
      valNum = 0, student_choices = []
      console.log(vals)
      for(let i = 0; i < vals.length; i++) {
        let input = vals[i],
        value = input.querySelector('input').value,
        choice_id = Number(input.dataset.id)
        student_choices.push({choice_id, value})
        if(value) valNum++
      }
      
      this.answer_results.student_choices = student_choices
      this.recordQuestion = student_choices
      console.log(valNum)
      if(valNum >= 1) { 
        this.$emit('permissions', true)
        this.limit = valNum
      }
      else {
        this.$emit('permissions', false)
        this.limit = 0
      }
    },
    // 处理id
    handleDataId() {
      let fills = document.querySelectorAll('.ciphertext'),
      answers = this.form.answers
      
      for(let i = 0; i < fills.length; i++) {
        let fill = fills[i]
        fill.dataset.id = answers[i].choice_id
      }

    },
    initData() {
      this.recordQuestion = []
      
      let content = JSON.parse(this.form.content.replace(/\(\)/g, ''))
      console.log(content)
      for(let i = 0; i < content.length; i ++) {
        let blocks = content[i]
        for(let j = 0; j < blocks.length; j++) {
          let block = blocks[j],
          nextBlock = blocks[j + 1]
          if(block.type >= 0 && nextBlock && nextBlock.type < 0) {
            block.right = true
          }

          if(block.type >= 0 && (content[i + 1] && content[i + 1][j].type < 0)) {
            block.bottom = true
          }
        }
      }
      this.matrix = content

      this.$nextTick(() => {
        this.handleDataId()
      })

      setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    window.vue = this
    this.initData()
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
@import url('../../static/pubile.scss');

.question-view {
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-color: #fff !important;
  // border-radius: 10px;

  .matrix {
    margin-top: 20px;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;

    .column {
      width: 100%;
      display: flex;
      
      .direction {
        width: 38px;
        height: 38px;
        box-sizing: border-box;
        position: relative;
        border: 20px solid transparent;
      }

      .N {
        border-bottom-color: #717171;
      }
      .S {
        border-top-color: #717171;
      }
      .E {
        border-left-color: #717171;
      }
      .W {
        border-right-color: #717171;
      }

      .row {
        width: 80px;
        height: 60px;
        // padding: 2px;
        box-sizing: border-box;
        position: relative;
        border: 1px solid #717171;
         //box-shadow: 0 0 0 1px #717171;
        //border-right: none;
        //border-bottom: none;
        background-color: #ffcca5;

        .proclaimed, .ciphertext {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 700;
        }

        input[type="number"] {
          outline: none;
          border: none;
          width: 100%;
          height: 100%;
          background-color: transparent;
          text-align: center;
          color: #ff3550;
          font-weight: 700;
          font-size: 16px;
        }
      }

      .right:before {
        content: '';
        position: absolute;
        top: -2px;
        right: -2px;
        width: 2px;
        height: calc(100% + 2px);
        background-color: #717171;
      }

      .bottom:after {
        content: '';
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: calc(100% + 4px);
        height: 2px;
        background-color: #717171;
      }

      .row.hide {
        background-color: transparent;
        border: none;

        &:after, &:before {
          content: none;
        }
      }
    }
  }
  .quest-img {
  margin-left: 10px;
    width: 833px;/*width: 833px;*/
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      border-radius: 5px;
    }
  }
}
.no-spin {
  -moz-appearance: textfield;
  appearance: textfield;
}
.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
